enum OnboardingEventBit {
  // https://docs.google.com/document/d/1aMvvxFDGo4IEmEX5X_myOWgORJN-IefkdlmiuN_8l_U/edit?tab=t.0#heading=h.zi84rfws7eyo

  // Insurance
  CommerciallyInsured = 'i1',
  Medicare = 'i2',
  Medicaid = 'i3',

  // Substance
  Stimulants = 's1',
  Alcohol = 's2',
  Cannabis = 's3',
  Opioids = 's4',
  MentalHealth = 's5',

  // Treatability
  Treatable = 'T'
}

export default OnboardingEventBit;
